import NotificationSettingsAlertDialog from './NotificationSettingsAlertDialog';

export * from './NotificationSettingsAlertDialog.types';

export default NotificationSettingsAlertDialog;
